const { apmTypeMapper, apmType } = require('../apms/apmsMapper');
const _ = require('lodash');

const gatewayType = {
    nexio: 1,
    nexio_auto: 2,
    nexio_async: 3,
    usaepay: 10,
    nmi: 20,
    nmi_card_vault: 21,
    nmi_auto: 22,
    acapture: 30,
    authorize: 40,
    creditcall: 50,
    moneris: 60,
    stripe: 70,
    cardflight: 80,
    kiwoompay: 90,
    aci_auto: 100,
    aci_planet: 101,
    aci_planet_mcp: 102,
    zeamster: 110,
    reach: 120,
    switch: 130,
    switch_kicc: 131,
    switch_cardnet: 132,
    openpay: 140,
    payments_os: 150,
    payments_os_turkey: 151,
    payments_os_south_africa: 152,
    payments_os_colombia: 153,
    payments_os_russia: 154,
    payments_os_asia_pacific: 155,
    payments_os_nigeria: 156,
    payments_os_india: 157,
    payments_os_iyzico: 158,
    checkout: 160,
    checkout_nas: 161,
    kushki: 170,
    kushki_ecuador: 171,
    propay: 180,
    propay_canada: 181,
    cybersource: 190,
    trust_my_travel: 200,
    powercash: 210,
    emerchantpay: 220,
    adyen: 230,
    place_to_pay: 240,
    bambora: 250,
    ntt_cybersource: 260,
    ntt: 262,
    cardinalCommerce: 270
};

const gatewayInterfaceType = {
    kushki: 170,
    payments_os: 150
};

const cardVerificationProviderGatewayType = {
    nmi: 20,
    nexio: 1
};

const cardVerificationProviderGatewayTypeMapper = _.invert(cardVerificationProviderGatewayType);

const gatewayTypeMapper = _.invert(gatewayType);

const gatewayAndApmMapper = Object.assign({}, gatewayTypeMapper, apmTypeMapper);

const gatewayAndApmType = {
    ...gatewayType,
    ...apmType
};

const unknownGatewayIssue = '-...unknown';

function gatewayLabelUpdate(gateway) {
    if (gateway.label && gateway.label !== unknownGatewayIssue) {
        // If we already have a label and it isn't unknown, then we are done.
        return;
    }

    try {
        const credentials = gateway.credentials;
        let gatewayTypeValue = gateway.gatewayType || gateway.type;
        switch (gatewayTypeValue) {
            case gatewayType.usaepay:
                // sourceKey & pin
                gateway.label = `-...${credentials.sourceKey.slice(-4)}`;
                break;
            case gatewayType.nmi:
                // username & password && processorId
                if (_.get(credentials, 'securityKey')) {
                    gateway.label = `-sk:...${credentials.securityKey.slice(-4)},${credentials.processorId}`;
                } else {
                    gateway.label = `-...${credentials.username.slice(-4)},${credentials.processorId}`;
                }
                break;
            case gatewayType.nmi_card_vault:
                // username & password && processorId
                gateway.label = `-...${credentials.username.slice(-4)},${credentials.processorId}`;
                break;
            case gatewayType.nmi_auto:
                // username & password && processorId
                gateway.label = `-...${credentials.username.slice(-4)},${credentials.processorId}`;
                break;
            case gatewayType.acapture:
                // userId & password & entityId
                gateway.label = `-...${credentials.userId.slice(-4)},${credentials.entityId}`;
                break;
            case gatewayType.authorize:
                // loginId & transactionKey
                gateway.label = `-...${credentials.transactionKey.slice(-4)},${credentials.loginId}`;
                break;
            case gatewayType.creditcall:
                // serialNumber & terminalId & transactionKey
                gateway.label = `-...${credentials.serialNumber.slice(-4)},...${credentials.terminalId.slice(-4)}`;
                break;
            case gatewayType.moneris:
                // apiKey ???
                gateway.label = `-...${credentials.apiKey.slice(-4)}`;
                break;
            case gatewayType.stripe:
                // secretKey
                gateway.label = `-...${credentials.secretKey.slice(-4)}`;
                break;
            case gatewayType.cardflight:
                // apiToken & accountToken
                gateway.label = `-...${credentials.apiToken.slice(-4)}`;
                break;
            case gatewayType.kiwoompay:
                // apiKey ???
                gateway.label = `-...${credentials.apiKey.slice(-4)}`;
                break;
            case gatewayType.aci_auto:
            case gatewayType.aci_planet:
            case gatewayType.aci_planet_mcp:
                // userId & password & entityId
                gateway.label = `-...${credentials.userId.slice(-4)},${credentials.entityId}`;
                break;
            case gatewayType.zeamster:
                // userId & userApiKey & productTransactionId
                gateway.label = `-...${credentials.userId.slice(-4)},...${credentials.productTransactionId.slice(-4)}`;
                break;
            case gatewayType.reach:
                // ReachMerchantId & Secret
                gateway.label = `-...${credentials.reachMerchantId.slice(-4)},...${credentials.secret.slice(-4)}`;
                break;
            case gatewayType.switch:
            case gatewayType.switch_kicc:
            case gatewayType.switch_cardnet:
                // accountId & publicKey & privateKey
                gateway.label = `-...${credentials.accountId.slice(-4)},...${credentials.publicKey.slice(-4)}`;
                break;
            case gatewayType.openpay:
                // public key, private key, and id
                gateway.label = `-...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)},...${credentials.id}`;
                break;
            case gatewayType.payments_os:
            case gatewayType.payments_os_turkey:
            case gatewayType.payments_os_south_africa:
            case gatewayType.payments_os_colombia:
            case gatewayType.payments_os_russia:
            case gatewayType.payments_os_asia_pacific:
            case gatewayType.payments_os_nigeria:
            case gatewayType.payments_os_india:
            case gatewayType.payments_os_iyzico:
                // app_id, public_key, and private_key
                gateway.label = `-...${credentials.appId},...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)}`;
                break;
            case gatewayType.nexio:
            case gatewayType.nexio_auto:
            case gatewayType.nexio_async:
                gateway.label = credentials && _.get(credentials, 'username') ? `...${credentials.username}` : '';
                break;
            case gatewayType.checkout:
            case gatewayType.checkout_nas:
                // private key
                gateway.label = `-...${credentials.privateKey.substr(-4)}`;
                break;
            case gatewayType.kushki:
                // public Key, private Key
                gateway.label = `-...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)}`;
                break;
            case gatewayType.kushki_ecuador:
                // public Key, private Key
                gateway.label = `-...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)}`;
                break;
            case gatewayType.propay:
                // certStr , termId
                gateway.label = `-...${credentials.certStr.substr(-4)}...${credentials.termId.substr(-4)}...${credentials.accountNum.substr(-4)}`;
                break;
            case gatewayType.propay_canada:
                // certStr termId
                gateway.label = `-...${credentials.certStr.substr(-4)}...${credentials.termId.substr(-4)}...${credentials.accountNum.substr(-4)}`;
                break;
            case gatewayType.cybersource:
                gateway.label = `-...${credentials.cyberSourceMerchantId.substr(-4)}...${credentials.merchantKeyId.substr(-4)}...${credentials.merchantSecretKey.substr(-4)}`;
                break;
            case gatewayType.powercash:
                gateway.label = `-...${credentials.powercashMerchantId.substr(-4)}...${credentials.powercashSecret.substr(-4)}`;
                break;
            case gatewayType.trust_my_travel:
                gateway.label = `-...${credentials.username.substr(-4)}...${credentials.password.substr(-4)}`;
                break;
            case gatewayType.emerchantpay:
                gateway.label = `-...${credentials.username.substr(-4)}...${credentials.password.substr(-4)}`;
                break;
            case gatewayType.adyen:
                gateway.label = `-${credentials.merchantAccountName},...${credentials.apiKey.substr(-4)}`;
                break;
            case gatewayType.place_to_pay:
                gateway.label = `-${credentials.login},...${credentials.secretKey.substr(-4)}`;
                break;
            case gatewayType.bambora:
                gateway.label = `-${credentials.bamboraMerchantId},${credentials.accessPasscode.substr(-4)},...${credentials.paymentPasscode.substr(-4)},...${credentials.reportingPasscode.substr(-4)}`;
                break;
            case gatewayType.ntt:
            case gatewayType.ntt_ctbc:
            case gatewayType.ntt_cybersource:
            case gatewayType.ntt_ipay88:
            case gatewayType.ntt_mpgs:
                gateway.label = `-${credentials.apiLogin},${credentials.apiPassword.substr(-4)},...${credentials.signatureKey.substr(-4)},...${credentials.aesCardEncryptionKey.substr(-4)}`;
                break;
            case gatewayType.cardinalCommerce:
                gateway.label = `-...${credentials.cardinalOrgUnitId.substr(-4)},...${credentials.cardinalApiIdentifier.substr(-4)},...${credentials.cardinalApiKey.substr(-4)}`;
                break;
            default:
                gateway.label = unknownGatewayIssue;
        }
    } catch (e) {
        console.error('Gateway Label Creation Error:', e);
        gateway.label = unknownGatewayIssue;
    }
}

const slyceGatewayType = [
    'usaepay',
    'usaepayx',
    'creditcall',
    'moneris',
    'nmi',
    'acapture',
    'stripe',
    'authorize',
    'cardflight',
    'smartpay'
];

module.exports = {
    gatewayType,
    gatewayInterfaceType,
    cardVerificationProviderGatewayType,
    cardVerificationProviderGatewayTypeMapper,
    gatewayTypeMapper,
    gatewayAndApmMapper,
    gatewayAndApmType,
    gatewayLabelUpdate,
    slyceGatewayType
};